module.exports = __webpack_public_path__ + "img/renaissance_cleaning_services_6.3a6a4108.jpg";